export default "__VITE_ASSET__3d5a9682__"